export default __webpack_public_path__ + "static/media/TSRLogo.7002ff14.png";